import type { MultiBrandConfig } from './types';

// Website 08 — Coastal Freedom Travel eSIM storefront. Sunny vacation/leisure
// lifestyle brand: bright white UI, bold navy headlines, blue CTAs, coastal
// lifestyle photography, embedded hero plan widget, high-data/vacation framing
// (coast-day / coast-night palettes). Sells the FEELING of staying connected on
// holiday, not a technical product. Name/domain PROVISIONAL.
//
// DOMAIN NOTE: points at esimsupra.com for now (shared backend). Needs its own
// canonical domain + contact email before launch. Build-selectable for preview
// only (BRAND_ID=coastal-freedom-travel-esim).
//
// CLAIM-SAFETY: the mockups use "Trusted by 1M+ travelers", "4.8/5 based on
// 12,458 reviews", and "unlimited" framing. NONE are reproduced. High-data
// plans are described transparently ("large data / plenty of data"), trust is
// rebuilt with neutral supportable copy, and there is no AggregateRating.
export const coastalFreedom: MultiBrandConfig = {
  id: 'coastal-freedom-travel-esim',
  status: 'provisional',
  siteType: 'storefront',
  positioning:
    'Sunny, lifestyle-led travel eSIM for vacation, beach, island and high-data leisure travelers — emotional freedom framing, vacation-specific data guidance, photo-rich plan selection and a relaxed, brochure-style journey over a technical marketplace feel.',
  theme: {
    mode: 'light', // bright sunlit white, light-first
    defaultDark: 'coast-night',
    defaultLight: 'coast-day',
  },
  checkoutEnabled: true,
  // Vacation brand: lead with higher-data plans for trips. Presentation only.
  pricingDisplayMode: 'vacation-high-data',
  legacy: {
    brand: {
      name: 'Coastal Freedom',
      displayName: 'Coastal Freedom',
      tagline: 'Stay connected everywhere you go',
      description:
        'Travel eSIMs for sunny getaways. Pick your destination, choose plenty of data for maps, social and video calls, and get connected the moment you arrive — no physical SIM, no roaming fees, total travel freedom.',
      logo: '/images/assets/logo.svg',
      logoAlt: 'Coastal Freedom Logo',
    },
    contact: {
      // TODO(brand-email): planned dedicated inbox `hello@esimcoast.com` (TBD) before indexed launch (R14). Shared inbox for now.
      email: 'contact@esimsupra.com',
      phone: '',
      phoneFormatted: '',
      whatsapp: '',
      address: 'Available Worldwide',
      supportHours: '24/7 Support',
    },
    website: {
      url: 'https://esimsupra.com',
      domain: 'esimsupra.com',
    },
    social: {
      facebook: '',
      twitter: '',
      instagram: '',
      youtube: '',
      telegram: '',
    },
    resources: {
      compatibilityUrl: '#',
      compatibilityLabel: 'Check Device Compatibility',
    },
    legal: {
      copyrightYear: new Date().getFullYear().toString(),
      copyrightText: `© ${new Date().getFullYear()} Coastal Freedom. All rights reserved.`,
    },
    features: {
      count180Countries: '200+ Destinations',
      uptimePerformance: 'High-Speed Networks',
      support247: '24/7 Support',
    },
    ui: {
      theme_palette_selector: true,
    },
  },
  tech: {
    analytics: {
      gtmId: 'TBD — provision per-brand GTM container ID in Google Tag Manager',
      ga4Id: 'TBD — provision per-brand GA4 measurement ID in Google Analytics',
      metaPixelId: 'TBD — provision per-brand Pixel ID in Meta Events Manager',
      googleAdsConversionId: 'TBD — provision per-brand conversion ID in Google Ads',
      googleAdsPurchaseLabel: 'TBD — provision per-brand purchase conversion label in Google Ads',
    },
    trustpilot: {
      businessUnitId: 'TBD — create Trustpilot Business Unit for esimcoast.com',
      locale: 'en-US',
    },
    stripe: {
      statementDescriptorSuffix: 'COASTAL',
      accountId: 'TBD — create Stripe Connect account or use statement_descriptor_suffix on shared account',
    },
    canonical: {
      domain: 'esimcoast.com',
      url: 'https://esimcoast.com',
      organizationLegalName: 'TBD — register legal entity for Coastal Freedom',
    },
    llms: {
      tagline: 'Sunny, stress-free connectivity for your getaway',
      audience: 'Vacation and leisure travelers who want plenty of data and a relaxed, freedom-led experience.',
    },
  },
};

export default coastalFreedom;
